import { round } from 'lodash';
import Dinero from 'dinero.js';
import { formatDateTime, DATE_TIME_TZ } from '@koob/dates';

export const formatCurrency = ({
  amount,
  currency,
  showDecimals = true,
  decimals,
}) => {
  if (!amount && amount !== 0) {
    return '';
  }

  if (!currency) {
    return amount.toString();
  }

  const hideDecimals = showDecimals === false || decimals === 0;

  try {
    const formatted = Dinero({ amount: Math.round(amount * 100), currency })
      .setLocale('fr')
      .toFormat()
      .toUpperCase();

    if (hideDecimals) {
      return formatted.replace(/[,.]00(?=[\s\u00A0\u202F]|$)/, '');
    }

    return formatted;
  } catch (err) {
    return amount;
  }
};

export const accordeonDetailsPolicies = (translationData, policies) => {
  const policiesFormatted = [
    {
      description: { displayName: translationData.displayName },
      content: policies?.cancelConditions
        ? `${policies.cancelConditions
            .map((cc) => {
              return `${translationData.from}
          "${formatDateTime(cc.startAt, DATE_TIME_TZ)}" ${translationData.to}${' '}
          "${formatDateTime(cc.endAt, DATE_TIME_TZ)}"${', '}
          ${translationData.cancellationFees} ${'= '} ${formatCurrency({
            amount: round(cc.deduction, 2),
            currency: cc.currency ?? translationData.currency,
          })}<br><br>`;
            })
            .join('')}${
            policies?.contractingConditions
              ? policies.contractingConditions
              : ''
          }`
        : undefined,
    },
  ];
  return policiesFormatted ?? '';
};
